import { ProductStatus } from 'gql/types';

const STATUS_COLORS: Record<ProductStatus, string> = {
  // 🟢 Success / Ready
  [ProductStatus.Available]: '#52c41a',
  [ProductStatus.Sold]: '#52c41a',

  // 🔴 Danger / Error
  [ProductStatus.Discarded]: '#ff4d4f',

  // 🟡 Warning / Pending
  [ProductStatus.Pending]: '#faad14',

  // ⚪️ Neutral / In Progress
  [ProductStatus.Collected]: '#8c8c8c',
  [ProductStatus.Processed]: '#8c8c8c',
  [ProductStatus.Cryoprecipitate]: '#8c8c8c',
};

export const getProductStatusDotColor = (status: ProductStatus): string => {
  return STATUS_COLORS[status] || '#d9d9d9';
};
